class BxfRadioGroupConstants {
    static STRING = {
        BXF_RADIO_GROUP_WRAPPER: 'bxf-radio-group__wrapper',
        BXF_RADIO_GROUP_STACKED: 'bxf-radio-group__stacked',
        BXF_RADIO_GROUP_VERTICAL_CONTENT: 'bxf-radio-group__vertical-content',
        BXF_RADIO_GROUP_HORIZONTAL_CONTENT: 'bxf-radio-group__horizontal-content',
        BXF_RADIO_GROUP_VERTICAL_CONTENT_COMPACT: 'bxf-radio-group__vertical-content--compact',
        BXF_RADIO_GROUP_HORIZONTAL_CONTENT_COMPACT: 'bxf-radio-group__horizontal-content--compact',
        BXF_RADIO_GROUP_HEADER: 'bxf-radio-group__header',
        BXF_RADIO_GROUP_HEADER_BOLD: 'bxf-radio-group__header--bold',
        BXF_RADIO_GROUP_HEADER_INLINE: 'bxf-radio-group__header--inline',
        BXF_RADIO_GROUP_HEADER_COMPACT: 'bxf-radio-group__header--compact',
        BXF_RADIO_GROUP_HEADER_WITH_INSTRUCTIONAL_TEXT: 'bxf-radio-group__header--instructional-text',
        BXF_RADIO_GROUP_ERROR_MESSAGE: 'bxf-radio-group__message--error',
        BXF_RADIO_GROUP_WARNING_MESSAGE: 'bxf-radio-group__message--warning',
        DEFAULT_REQUIRED_VALIDATION_ERROR: 'At least one selection is required',
        REQUIRED_SYMBOL: 'bxf-radio-group__label--required',
        BXF_RADIO_GROUP_CONTAINER_VERTICAL: 'bxf-radio-group__container-vertical',
        BXF_RADIO_GROUP_CONTAINER_HORIZONTAL: 'bxf-radio-group__container-horizontal',
        BXF_RADIO_GROUP_HORIZONTAL: 'bxf-radio-group__horizontal',
        BXF_RADIO_GROUP_VERTICAL: 'bxf-radio-group__vertical',
        ASTERISK: '*',
        INSTRUCTIONAL_TEXT: 'bxf-radio-group__instructional-text',
        INSTRUCTIONAL_TEXT_COMPACT: 'bxf-radio-group__instructional-text--compact',
    };
}

class BxfRadioConstants {
    static STRING = {
        CONTAINER: 'bxf-radio__container',
        CONTAINER_CARD_HEADER: 'bxf-radio__container--card-header',
        RADIO: 'bxf-radio',
        RADIO_ICON: 'bxf-radio__icon',
        DISABLED: 'bxf-radio__disabled',
        READONLY: 'bxf-radio__readonly',
        BXF_RADIO_VALIDATION_ERROR: 'bxf-radio__validation-error',
        BXF_RADIO_VALIDATION_WARNING: 'bxf-radio__validation-warning',
        LABEL: 'bxf-radio__label-container',
        LABEL_RIGHT: 'bxf-radio__label-container--right',
        LABEL_SPAN: 'bxf-radio__label-span',
        LABEL_DISABLED: 'disabled',
        LABEL_READONLY: 'bxf-radio__label--readonly',
        SECONDARY_LABEL: 'bxf-radio__secondary-label',
        SECONDARY_LABEL_GROUP: 'bxf-radio-group__secondary-label',
        SECONDARY_LABEL_RIGHT: 'bxf-radio__secondary-label--right',
    };
}

export { BxfRadioGroupConstants as B, BxfRadioConstants as a };
